import React, { useState, useRef } from "react";

const ImageUploader = ({
  name,
  value,
  onChange,
  maxSize = 1024 * 1024 * 80,
  maxWidth = 800,
  quality = 0.7,
}) => {
  const [preview, setPreview] = useState(value || null);
  const [error, setError] = useState(null);
  const fileInputRef = useRef(null);

  // Funzione per comprimere e ridimensionare l'immagine
  const compressImage = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          let width = img.width;
          let height = img.height;

          // Mantiene le proporzioni se l'immagine è più grande del maxWidth
          if (width > maxWidth) {
            height = Math.round((height * maxWidth) / width);
            width = maxWidth;
          }

          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);

          // Converte il canvas in base64 con la qualità specificata
          const dataUrl = canvas.toDataURL(file.type, quality);
          resolve(dataUrl);
        };

        img.onerror = (error) => {
          reject(error);
        };
      };

      reader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Controllo dimensione file (default 2MB)
    if (file.size > maxSize) {
      setError(
        `L'immagine è troppo grande. La dimensione massima è ${Math.floor(
          maxSize / 1024 / 1024
        )}MB.`
      );
      return;
    }

    // Controllo tipo file
    if (!file.type.startsWith("image/")) {
      setError("Per favore seleziona un'immagine valida (JPG, PNG, GIF).");
      return;
    }

    setError(null);

    try {
      // Comprime e ridimensiona l'immagine
      const compressedImage = await compressImage(file);
      setPreview(compressedImage);
      onChange(compressedImage);
    } catch (error) {
      console.error("Errore durante la compressione dell'immagine:", error);
      setError(
        "Si è verificato un errore durante l'elaborazione dell'immagine."
      );
    }
  };

  const handleRemoveImage = () => {
    setPreview(null);
    onChange(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleClickUpload = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div style={{ marginBottom: "20px" }}>
      <div style={{ fontWeight: "bold", marginBottom: "5px" }}>{name}</div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        {preview && (
          <div style={{ marginBottom: "10px", position: "relative" }}>
            <img
              src={preview}
              alt="Anteprima badge"
              style={{
                maxWidth: "200px",
                maxHeight: "200px",
                border: "1px solid #ddd",
                borderRadius: "4px",
              }}
            />
            <button
              onClick={handleRemoveImage}
              style={{
                position: "absolute",
                top: "5px",
                right: "5px",
                background: "rgba(255, 255, 255, 0.7)",
                border: "none",
                borderRadius: "50%",
                width: "24px",
                height: "24px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              ✕
            </button>
          </div>
        )}

        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          style={{ display: "none" }}
          ref={fileInputRef}
        />

        <button
          onClick={handleClickUpload}
          style={{
            padding: "8px 15px",
            backgroundColor: "#3f51b5",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            marginTop: "5px",
          }}
        >
          {preview ? "Cambia immagine" : "Carica immagine"}
        </button>

        {error && (
          <div style={{ color: "red", marginTop: "5px", fontSize: "14px" }}>
            {error}
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageUploader;
